<template>
    <settings-page
        v-slot="{ formProcessing, onSubmit }"
        :show="show"
        class="show-settings-podcast"
    >
        <podcast-info
            :show="show"
            :form-processing="formProcessing"
            :on-change="updateShow"
            @submit="() => onSubmit(formData)"
        />

        <directory-info
            v-if="show.hosted"
            :show="show"
            :form-processing="formProcessing"
            :on-change="updateShow"
            @submit="() => onSubmit(formData)"
        />
    </settings-page>
</template>
<script>
import { pickBy } from 'lodash';
import { convertToFormData } from '@/utils/formData';
import PodcastInfo from '@/components/Shows/Settings/PodcastInfo';
import DirectoryInfo from '@/components/Shows/Settings/DirectoryInfo';
import SettingsPage from './SettingsPage';

export default {
    components: {
        PodcastInfo,
        DirectoryInfo,
        SettingsPage,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    data: () => ({
        showData: {},
    }),

    computed: {
        /**
         * Returns show data as form data.
         *
         * @returns {FormData} Show data.
         */
        formData() {
            return convertToFormData(
                pickBy(this.showData, (value, key) => {
                    if (
                        ('description' === key && ! this.show.hosted) ||
                        ('artwork' === key && ! this.show.hosted) ||
                        ('feedUrl' === key && this.show.hosted)
                    ) {
                        return false;
                    }

                    return true;
                })
            );
        },
    },

    methods: {
        /**
         * Updates show data.
         *
         * @param  {object} data New show data.
         */
        updateShow(data) {
            this.showData = {
                ...this.showData,
                ...data,
            };
        },
    },
};
</script>
